import React from "react";
import { Box } from "@mui/material";

interface TypingIndicatorProps {
  color?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  color = "#23586e",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        alignItems: "center",
        padding: "6px 0",
      }}
    >
      {[0, 1, 2].map((dot) => (
        <Box
          key={dot}
          sx={{
            width: "8px",
            height: "8px",
            backgroundColor: color,
            borderRadius: "50%",
            animation: "bounce 1.5s infinite ease-in-out",
            animationDelay: `${dot * 0.2}s`,
            "@keyframes bounce": {
              "0%, 100%": {
                transform: "translateY(0)",
              },
              "50%": {
                transform: "translateY(-5px)",
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default TypingIndicator;
